module.exports = __webpack_public_path__ + "img/indogrosir.ca3b797c.png";